<script>
export default {
  name: "error404"
}
</script>

<template>
<v-container class="text-center">
  <span class="body-2">ERROR</span>
  <br>
Contact support for help.
</v-container>
</template>

<style scoped>

</style>
